import { _ } from "ynf-core-middleware";
import { TableStore } from "../TableStore";
import { ColumnsType } from "../types";
import { BaseRowStore } from "../row/BaseRowStore"
import { BaseColumn } from "./BaseColumn";

export class CharacterColumn extends BaseColumn {
  type?: string
  constructor(column: ColumnsType, tableStore: TableStore) {
    super(column, tableStore);
    this.type = column.bizType || column.type || ''
    if (!column.defaultValue) this.defaultValue = {}
  }

  setValue(value: any, row: BaseRowStore<any>) {
    row.setTrueValue(this.getField(), value, true)
  }

  getValue(row: BaseRowStore<any>) {
    return row.getTrueValue(this.getField()) || undefined;
  }
}
